"use client";

import { createContext, useContext, useState } from "react";

export const GlobalStateContext = createContext({
  externalLink: undefined,
  setExternalLink: async (link) => null,
  externalModalId: null,
  setExternalModalId: async (id) => null,
  scrollMargin: 0,
  setScrollMargin: async (val) => 0,
  persistSubNav: undefined,
  setPersistSubNav: async (persist) => null,
  scrollSpyIndex: -1,
  setScrollSpyIndex: async (val) => null,
  inputFocused:false,
  setInputFocused: async (val) => null,
  siteData: {},
  setSiteData: async (data) => null,
})

export const useGlobalState = () => useContext(GlobalStateContext)

export const GlobalStateProvider = ({ children, siteData }) => {
  const [externalLink, setExternalLink] = useState(null)
  const [externalModalId, setExternalModalId] = useState(null)
  const [persistSubNav, setPersistSubNav] = useState(false)
  const [scrollMargin, setScrollMargin] = useState(141)
  const [inputFocused, setInputFocused] = useState(false)
  const [scrollSpyIndex, setScrollSpyIndex] = useState(-1)

  const [data, setSiteData] = useState(siteData)

  return (
    <GlobalStateContext.Provider value={{
      siteData: data,
      setSiteData,
      externalLink,
      setExternalLink,
      externalModalId,
      setExternalModalId,
      scrollMargin,
      setScrollMargin,
      persistSubNav,
      setPersistSubNav,
      scrollSpyIndex,
      setScrollSpyIndex,
      inputFocused,
      setInputFocused
    }}>
      {children}
    </GlobalStateContext.Provider>
  )
}